// import Button from '../common/button/button';
// import ProgressBar from '../common/progressBar/progressBar';
// import utilities from '../../utils/utils';
import Question from '../common/question/question';
import Radio from '../common/radio/radio';
import './questionWrapper.css';
import React from 'react';


const QuestionWrapper = ({ question, updateProgressFunc }) => {
    // const clickHandler = () => {
    //     alert('Button clicked!');
    // }

    // const clearHandler = () => {
    //     alert('Clear button clicked!');
    // };

    

    

    // let answerObj = {
    //     question: question.question,
        
    // }

    // if(question.multiSelect) {
    //     answerObj.selectedAnswers = [];
    // } else {
    //     answerObj.selectedAnswer = '';
    // }

    const handleChange = () => {
        setTimeout(() => {
            updateProgressFunc();
        }, 0);
    };

    return (

        
        <div className='question-wrapper'>
                <Question text={question.question}></Question>
                <Radio handleChangeEvent={handleChange} options={question.answers} followUpQ={question.followUpQuestion} question={question} maxCount={question.maxCount}></Radio>   
        </div>
    )
};

export default QuestionWrapper;